<template>
    <DefaultHeader currentPage="projects" />
    <main>
        <PageIntro title="Projects" :items="visibleProjects">
            Backend platforms and distributed systems — real-time telemetry, event-driven microservices and
            performance testing infrastructure.
        </PageIntro>

        <div class="container-page space-y-6">
            <ProjectEntry v-for="project in visibleProjects" :key="project.id" :project="project" />
        </div>
    </main>

    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/headers/DefaultHeader.vue'
import PageIntro from '@/components/ui/PageIntro.vue'
import ProjectEntry from '@/components/Projects/ProjectEntry.vue'
import DefaultFooter from '@/components/footers/DefaultFooter.vue'
import { projects } from '@/data/projects'

export default {
    components: {
        DefaultHeader,
        PageIntro,
        ProjectEntry,
        DefaultFooter
    },
    data() {
        return { visibleProjects: projects.filter((p) => !p.hidden) };
    }
}
</script>
